import React, { Component, Fragment } from 'react'
import theme, {whiteLabelData}  from '../../theme'

import PropTypes from 'prop-types'

import {withRouter} from "react-router";

import i18next, {t} from 'i18next';
import { Trans } from 'react-i18next'
import log from 'loglevel'

// Application Components
import AccountDeletion from "../User/AccountDeletion"

// Material components
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'
import Select from '@mui/material/Select';

const styles = {
    root: {
        padding: theme.spacing(4),
        maxWidth: 420,
        boxSizing: 'border-box',
        width: '100%',
    },
    loginButton: {
        width: 95,
    },
    linkContainer: {
        marginTop: 50,
    },
    error: {
        color: theme.palette.error.main,
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: 12,
    },
    textForm: {
        [theme.breakpoints.up('xs')]: {
            width: 229,
        },
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },
    textField: {
        minWidth: 'inherit',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    selectLang: {
      fontSize: 12,
    }
}

class Onboarding extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: this.props.error,
            inputs: {
                deviceId: '',
                name: '',
            },
            showDelete: false,
            language: i18next.language
        };
    }

    static defaultProps = {
        error: false,
    }

    static propTypes = {
        error: PropTypes.bool,
        classes: PropTypes.objectOf(PropTypes.string).isRequired,
        onLogin: PropTypes.func.isRequired,
    }

    handleChangeInput = (key, value) => {
        const { inputs } = this.state;
        inputs[key] = value;
        this.setState({inputs});
    };

    Connect = () => {
        const { inputs: {DevicID, name}} = this.state;
        log.debug("DevicID", DevicID);
        this.props.onCreate(DevicID, name);
    };

    Stop = () => {
        this.props.history.push("/logout");
    }



    checkEnterSubmit = (ev) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            this.handleLogin();
        }
    };

    deleteAccount =() => {
        this.setState({showDelete: true})
    }

    handleLanguageChange = (event) => {
      i18next.changeLanguage(event.target.value)
      this.setState({language: event.target.value})
    }

    render () {
        const { classes } = this.props
        const { error, inputs: {DeviceID, name} } = this.state;
        return (
          <Grid
              container
              direction="column"
              justifyContent="center"  // Vertikale Zentrierung
              alignItems="center"        // Horizontale Zentrierung
              style={{ minHeight: '100vh', padding: theme.spacing(2) }} // Füllt die Bildschirmhöhe
          >
            <Grid container justifyContent="center">
              <Grid item style={{ marginBottom: 20 }}>
                <img style={{ width: '100%', maxWidth: '300px' }} src={whiteLabelData.logo} alt="" />
              </Grid>
            </Grid>
              <Paper style={styles.root}>
                <Grid container direction="column" justify="center" alignItems="center">
                    <Typography style={{ fontSize: 20 }}>
                        {t('Onboarding.title_device_registration')}
                    </Typography>
                    <Typography><Trans i18nKey="Onboarding.helper_text_device_registration"></Trans></Typography>
                    <Grid container justifyContent="center" alignItems="center" direction="column">
                      <TextField
                          InputProps={{
                              classes: {
                                  underline: styles.textFieldUnerline
                              },
                          }}
                          InputLabelProps={{
                              FormLabelClasses: {
                                  root: styles.textFieldFormLabel,
                                  focused: styles.textFieldFocused,
                              },
                          }}
                          error={error}
                          name={'DevicID'}
                          type={'text'}
                          value={DeviceID}
                          label="Device ID"
                          fullWidth={true}
                          margin="normal"
                          style={styles.textField}
                          onChange={e => this.handleChangeInput(e.target.name, e.target.value)}
                      />

                      <TextField
                          InputProps={{
                              classes: {
                                  underline: styles.textFieldUnerline
                              },
                          }}
                          InputLabelProps={{
                              FormLabelClasses: {
                                  root: styles.textFieldFormLabel,
                                  focused: styles.textFieldFocused,
                              },
                          }}
                          error={error}
                          name={'name'}
                          type={'text'}
                          value={name}
                          label="Name"
                          fullWidth={true}
                          margin="normal"
                          style={styles.textField}
                          onChange={e => this.handleChangeInput(e.target.name, e.target.value)}
                        />

                    </Grid>
                    <Button style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                            variant="outlined"
                            fullWidth={true}
                            color="primary"
                            onClick={this.Connect}
                    >
                        <Trans i18nKey="Devices.button_connect"></Trans>
                    </Button>
                    <Button style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                            variant="outlined"
                            fullWidth={true}
                            color="primary"
                            onClick={this.Stop}
                    >
                        <Trans i18nKey="Global.button_back"></Trans>
                    </Button>
                    <Button style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                            variant="outlined"
                            fullWidth={true}
                            color="primary"
                            onClick={this.deleteAccount}
                    >
                        <Trans i18nKey="User.button_delete_account"></Trans>
                    </Button>
                    {this.state.showDelete &&
                    <AccountDeletion onRequestDeletion={this.props.deleteUser}
                                      onSuccess={this.Stop}
                    />
                    }

                </Grid>
              </Paper>
            <Grid container justifyContent="center">
              <Grid item style={{ marginTop: 20 }}>
                <Select
                  native
                  disableUnderline
                  labelId={t('ChooseLanguage.button_choose_language')}
                  id="login_language_selectt"
                  value={this.state.language}
                  onChange={this.handleLanguageChange}
                  style={styles.selectLang}
                >
                  <option value='en'>English</option>
                  <option value='de'>Deutsch</option>
                </Select>
              </Grid>
            </Grid>
          </Grid>
        )
    }
}

export default withRouter(Onboarding)
